import Lottie from "lottie-react";
import React, { useEffect } from "react";
import Loading from "../../../assets/images/gif/sdap-loading.json";
import { ROUTES } from "../../../configs/routes";
import { useAuth } from "../../../hooks/auth-hooks";

import "./DigitalLegacyAuth.scss";
import { Cookie } from "../../../services/storage";
import { REDIRECT_URI, REQUEST_NUMBER } from "../../../constants/storage";
import { SP_SPDL_TICKET_NUMBER } from "../../../constants/ticketNumberRegex";
import { UtilsUser } from "../../../utils/UtilsUser";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { LayoutState } from "../../../store/reducers/layout-reducer";

export const DigitalLegacyAuth: React.FC = () => {
  const layoutState = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );
  const { isLanguageReady, languageTrans } = layoutState;
  const { login } = useAuth();
  const currentURL = window.location.pathname;

  const handleDeeplinkRequestForDL = () => {
    const reqNum = currentURL.split("/").pop();
    const isDLRequestDeepLink = reqNum?.match(SP_SPDL_TICKET_NUMBER);

    //Cleanup for redirect URL cookie
    Cookie.remove(REDIRECT_URI);
    if (reqNum && isDLRequestDeepLink && !UtilsUser.isUserLoggedIn()) {
      Cookie.set(REQUEST_NUMBER, reqNum);
      Cookie.set(REDIRECT_URI, `${ROUTES.MYDATA_HISTORY}/${reqNum}`);
    }
  };
  useEffect(() => {
    if (isLanguageReady && languageTrans !== "") {
      handleDeeplinkRequestForDL();
      login(ROUTES.MYDATA, true);
    }
  }, [isLanguageReady, languageTrans]);

  return (
    <>
      <Lottie
        className="dl-route__loading"
        animationData={Loading}
        loop={true}
        style={{ width: 60, height: 60 }}
      />
    </>
  );
};

export default DigitalLegacyAuth;
